import { css } from '@emotion/css';

export const createScorecardBtnStyles = css`
  :hover {
    background: transparent;
  }
`;
